import { LunchroulettePage } from './../lunchroulette/lunchroulette';
import { Component } from '@angular/core';
import { HomePage } from '../home/home';
import { NetworkPage } from '../network/network';
import { NotificationsPage } from '../notifications/notifications';
import { PollPage } from '../poll/poll';
import { NotificationProvider } from '../../../providers/notification/notification';
import { AuthProvider } from '../../../providers/auth/auth';
import { MessagingPage } from "../messaging/messaging";
import { ProfilePage } from "../profile/profile";
import { MenuProfile } from "../menu-profile/menu-profile";
import { RhDashboardPage } from '../_rh/dashboard/rh-dashboard';

@Component({
  templateUrl: 'tabsRh.html'
})
export class TabsPageRh {

  tab1Root = MessagingPage;
  tab2Root = RhDashboardPage;
  tab3Root = MenuProfile;

  notifications: number = 0;


    constructor(public notificationProvider: NotificationProvider, public authProvider: AuthProvider) {

  }

  ngOnInit() {
    this.notificationProvider.getAll().subscribe((res) => {
      if(res.success){

        res.data.forEach(notification => {

          notification.user_id != this.authProvider.user.user_id ? this.notifications++ : '';
        });
      }
  })
}


}



// WEBPACK FOOTER //
// ./src/pages/employee/tabsRh/tabsRh.ts